(function () {
 var CTA_ID = "lb-slidein-cta";
 var DELAY_MS = (window.Shopify && Shopify.designMode) ? 300 : 5000;


 // Alleen sluiten moet de CTA voor de rest van de sessie uitschakelen
 var STORAGE_KEY = "lb_slidein_cta_closed_session";


 function canUseSessionStorage() {
   try {
     var s = window.sessionStorage;
     if (!s) return false;
     var testKey = "__lb_test__";
     s.setItem(testKey, "1");
     s.removeItem(testKey);
     return true;
   } catch (e) {
     return false;
   }
 }


 var hasSessionStorage = canUseSessionStorage();


 function init() {
   var cta = document.getElementById(CTA_ID);
   if (!cta) return;


   // Voorkom dubbel initialiseren (handig in Theme Editor)
   if (cta.dataset.lbInit === "1") return;
   cta.dataset.lbInit = "1";


   // Als tijdens deze sessie gesloten: niet meer tonen
   if (hasSessionStorage) {
     if (sessionStorage.getItem(STORAGE_KEY) === "1") return;
   }


   var showTimer = window.setTimeout(function () {
     // Check opnieuw (voor de zekerheid)
     if (hasSessionStorage && sessionStorage.getItem(STORAGE_KEY) === "1") return;


     cta.classList.add("is-visible");
     cta.setAttribute("aria-hidden", "false");
   }, DELAY_MS);


   function hideAndRemember() {
     // Zet flag: rest van de sessie niet meer tonen
     if (hasSessionStorage) {
       sessionStorage.setItem(STORAGE_KEY, "1");
     }


     // Als hij nog niet zichtbaar was, voorkomen dat timer 'm later toch toont
     window.clearTimeout(showTimer);


     cta.classList.remove("is-visible");
     cta.setAttribute("aria-hidden", "true");
   }


   var closeBtn = cta.querySelector(".lb-slidein-cta__close");
   if (closeBtn) closeBtn.addEventListener("click", hideAndRemember);


   // Escape sluit ook (optioneel, maar netjes)
   document.addEventListener("keydown", function (e) {
     if (e.key === "Escape" && cta.classList.contains("is-visible")) {
       hideAndRemember();
     }
   });
 }


 if (document.readyState === "loading") {
   document.addEventListener("DOMContentLoaded", init);
 } else {
   init();
 }


 // Theme editor reloads
 document.addEventListener("shopify:section:load", init);
})();